import * as Sentry from "@sentry/react";
import { YieldType } from "../../../service/globalTypes";
import { DATA_PRODUCER_WORKSHEET_NAME } from "../../../service/globalValues";
import { processDataProducerEvent } from "../../../service/producerServices";
import { ASK_IDX, BID_IDX, QUOTE_FEED_IDX } from "../../../service/producerServices/constants";
import { OnDataProducerArgs } from "../../types";
import { getSecurityYieldValueWithSpreadIfApplicable } from "./getSecurityYieldValueWithSpreadIfApplicable";

interface HandleCellValueArgs extends Omit<OnDataProducerArgs, "event"> {
  cell: string;
}

export const handleCellValue = async ({ cell, onSaveSecurityInStaging, onSetQuoteFeedAsNone }: HandleCellValueArgs) => {
  await Excel.run(async (context) => {
    const worksheet = context.workbook.worksheets.getItem(DATA_PRODUCER_WORKSHEET_NAME);
    const range = worksheet.getRange(cell);

    range.load(["values", "rowIndex", "columnIndex", "formulas"]);
    await context.sync();

    const editedColumnIndex = range.columnIndex;

    if (![ASK_IDX, BID_IDX, QUOTE_FEED_IDX].includes(editedColumnIndex)) return;

    try {
      const updatedYieldInfo: { updatedValue?: number; updatedValueYieldType?: YieldType } =
        getSecurityYieldValueWithSpreadIfApplicable({
          currentCellValue: range.values[0][0],
          cell,
          editedColumnIndex,
        });

      await processDataProducerEvent({
        context,
        isOnChanged: false,
        onSaveSecurityInStaging,
        range,
        worksheet,
        onSetQuoteFeedAsNone,
        ...updatedYieldInfo,
      });
    } catch (error) {
      Sentry.captureException(
        new Error('Error while executing handler cell value', { cause: error })
      );
    }
  });
};
